export enum DocumentType {
    PRESAILING = 'PRE SAILING',
    POSTSAILING = 'POST SAILING',
    PRELOADING = 'PRE LOADING',
}